var $ = require('jquery')

module.exports = function ajaxIsUserScheGame(gameCode, uid) {
  var dtd = $.Deferred();
  var isFollowed = false;
  var url = 'https://api.17173.com/hao/v1/IsUserScheGame?passport_id='+uid+'&game_codes='+gameCode;

  $.ajax({
    url:url,
    dataType: 'jsonp'
  })
  .done(function(data){
    if (data.result = 'success') {
      isFollowed = data.data[gameCode];
    }
    dtd.resolve(isFollowed);
  })
  .fail(function(){
    dtd.resolve(isFollowed);
  })

  return dtd.promise();
}
